export function loadScript(src) {
    return new Promise((resolve, reject) => {
        // avoid loading the same script twice
        if (document.querySelector(`script[src="${src}"]`)) {
            return resolve();
        }

        const script = document.createElement('script');
        script.src = src;
        script.defer = true;
        script.onload = resolve;
        script.onerror = (err) => {
            script.remove();
            reject(err);
        };
        document.head.appendChild(script);
    });
}

export function loadCss(src) {
    return new Promise((resolve, reject) => {
        // avoid loading the same script twice
        if (document.querySelector(`link[href="${src}"]`)) {
            return resolve();
        }

        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = src;
        link.onload =  resolve;
        link.onerror = (err) => {
            link.remove();
            reject(err);
        };
        document.head.appendChild(link);
    });
}